/* ---- oferta: plano x quantidade, brindes que desbloqueiam ----------------
   Compartilhado por LP01 e LP02 (o bloco era identico nas duas).

   Os numeros NAO vivem mais aqui: vem de snippets/lp-offer-data.liquid, que
   publica variante, preco a vista e selling plan direto do produto da loja.
   Mudou preco ou plano no admin, a LP acompanha sem deploy.

   Assinatura manda variante + selling_plan; compra unica manda so a variante.
   Nos dois casos, /cart/add.js e depois /checkout. */

var LP_DATA = {};       /* qty -> {variantId, oncePrice, planId, planPrice, days, available} */
var KIT = { sub:{}, once:{} };
var GIFTVAL = [9.90, 14, 39];
/* brindes que viram linha de carrinho. Populado por readOffer() a partir do
   JSON do Liquid — o frete gratis nao entra aqui: ele e regra de perfil de
   envio, nao produto. */
var LP_GIFTS = [];
var plan = 'sub', qty = 3;

/* "Deliver every 4 weeks" -> 28. Sem match, cai em qty*30 (a copy antiga). */
function planDays(txt, q){
  var m = /(\d+)\s*(day|week|month)/i.exec(txt || '');
  if(!m) return q * 30;
  var n = +m[1], u = m[2].toLowerCase();
  return u === 'day' ? n : u === 'week' ? n * 7 : n * 30;
}

function readOffer(){
  var el = document.getElementById('lp-offer-data');
  if(!el) return false;
  var raw;
  try { raw = JSON.parse(el.textContent); } catch(e){ return false; }
  if(!raw || !raw.items || !raw.items.length) return false;
  LP_GIFTS = Array.isArray(raw.gifts) ? raw.gifts.filter(function(g){ return g && g.variantId; }) : [];

  raw.items.forEach(function(it){
    if(!it.qty) return;
    var once = it.oncePrice / 100;
    var onceDays = it.qty * 30;                     /* 30 dias por frasco, para o "por dia" */
    LP_DATA[it.qty] = {
      variantId: it.variantId,
      available: it.available !== false,
      planId: it.plan ? it.plan.id : null
    };
    KIT.once[it.qty] = {
      total: once, per: once / it.qty, day: once / onceDays,
      /* frete exibido: vem das settings da section, nao mais chumbado aqui.
         Liquid nao le delivery profile — conferir em Settings > Shipping. */
      ship: parseFloat(it.ship) || 0,
      days: onceDays
    };
    if(it.plan){
      /* dois numeros diferentes, que o codigo antigo tratava como um so:
         - "por dia" divide pelos dias de USO (1 frasco = 30 dias), o que mantem
           o $0.97 que aparece escrito nos CTAs da pagina;
         - "Ships every N days" e a cadencia REAL do selling plan (12 semanas =
           84 dias), nao os 90 que a maquete supunha. */
      var sub = it.plan.price / 100;
      KIT.sub[it.qty] = {
        total: sub, per: sub / it.qty, day: sub / onceDays, ship: 0,
        days: planDays(it.plan.every, it.qty)
      };
    }
  });

  /* se alguma quantidade nao tem assinatura, a LP nao pode abrir no plano */
  if(!KIT.sub[qty]) plan = 'once';
  return !!Object.keys(KIT.once).length;
}

function usd(n){ return '$' + n.toFixed(2); }
function bottles(n){ return n + ' bottle' + (n > 1 ? 's' : ''); }
function render(){
  /* uma quantidade sem plano nao pode travar o bloco inteiro */
  var d = KIT[plan][qty] || KIT.once[qty];
  if(!d) return;

  document.querySelectorAll('.pl').forEach(function(p){
    p.setAttribute('aria-selected', p.dataset.plan === plan);
  });

  document.querySelectorAll('.opt').forEach(function(o){
    var q = +o.dataset.qty, k = KIT[plan][q] || KIT.once[q];
    if(!k) return;
    o.setAttribute('aria-selected', q === qty);
    o.querySelector('.now').innerHTML = usd(k.per) + '<i> a bottle</i>';
    /* o riscado e o total real da compra unica na mesma pagina -- total contra total,
       nunca um preco cheio inventado */
    o.querySelector('.per').innerHTML =
      (plan === 'sub' ? '<s>' + usd(KIT.once[q].total) + '</s>' : '') + usd(k.total) + ' total';
    o.querySelector('.cad').innerHTML = plan === 'sub'
      ? 'Ships every ' + k.days + ' days<i> &middot; cancel anytime</i>'
      : (k.ship ? '+ ' + usd(k.ship) + ' shipping' : 'Free shipping<i> &middot; one shipment</i>');
  });

  var open = 0, value = 0;
  document.querySelectorAll('.gcard').forEach(function(g, i){
    var need = plan === 'sub' ? +g.dataset.needSub : +g.dataset.needOnce;
    var on = qty >= need, why = g.querySelector('.gneed');
    g.dataset.on = on ? '1' : '0';
    if(on){ open++; value += GIFTVAL[i]; why.textContent = 'Unlocked'; }
    else if(need > 3){ why.textContent = 'Flexible plan only'; }
    else { why.textContent = 'With ' + bottles(need); }
  });
  var tg = document.getElementById('ttlgifts');
  if(tg) tg.innerHTML = value
    ? '+ Free gift' + (open > 1 ? 's' : '') + ' <span class="g">(worth ' + usd(value) + ')</span>'
    : '';

  document.getElementById('ghint').innerHTML =
    open + ' of 3' + (value ? ' &middot; ' + usd(value) + ' value' : ' unlocked');

  var t3 = document.getElementById('tag3');
  if(t3) t3.innerHTML = plan === 'sub' ? 'best value &middot; all 3 gifts' : 'best value';

  /* o CTA do meio da pagina prometia frete gratis sem qualificar. Quem esta
     em 1 frasco a vista paga — a linha tem que dizer isso. */
  var sl = document.getElementById('shipline');
  if(sl) sl.innerHTML = (plan === 'once' && d.ship)
    ? '+ ' + usd(d.ship) + ' US shipping &middot; <b>ships in 24 hours</b>'
    : 'Free US shipping &middot; <b>ships in 24 hours</b>';

  var buy = document.getElementById('buybtn');
  if(buy){
    buy.querySelector('.lab2').innerHTML = plan === 'sub'
      ? 'Start the flexible plan' : 'Add to cart &mdash; ' + bottles(qty);
    buy.querySelector('.sub').innerHTML =
      bottles(qty) + ' &middot; ' + usd(d.per) + ' a bottle &middot; ' + usd(d.day) + ' a day';
  }

  var terms = document.getElementById('terms');
  if(terms){
    terms.innerHTML = plan === 'sub'
      ? usd(d.total) + ' today, then ' + usd(d.total) + ' every ' + d.days +
        ' days. <b>Skip, change or cancel in one click.</b>'
      : usd(d.total) + (d.ship ? ' + ' + usd(d.ship) + ' shipping' : '') +
        ' today. <b>One shipment. Nothing renews.</b>';
  }

  var pr = document.getElementById('dockpr'), db = document.getElementById('dockbtn');
  if(pr) pr.innerHTML = bottles(qty) + '<i class="dpb"> &middot; ' + usd(d.per) + ' a bottle</i>' +
    ' &middot; <b>' + usd(d.day) + ' a day</b>' +
    (open ? '<i class="dg"> &middot; <b>+' + open + ' gift' + (open > 1 ? 's' : '') + '</b></i>' : '');
  /* o chip do dock vende sempre as gummies: entrega quando estao abertas,
     aponta o caminho quando ainda nao estao */
  var dg = document.getElementById('dockgift');
  if(dg){
    dg.style.display = open ? '' : 'none';
    if(open) dg.querySelector('.dgtxt').innerHTML = open === 3
      ? '<b>+ 3 free gifts</b><i> &mdash; including a full bottle of ' +
        '<b class="hi">GutGlow Skin&nbsp;+&nbsp;Gut gummies</b></i>'
      : '<b>+ ' + open + ' free gift' + (open > 1 ? 's' : '') + '</b><i> &mdash; ' +
        (plan === 'sub' ? '3 bottles unlocks the ' : 'the flexible plan unlocks the ') +
        '<b class="hi">GutGlow gummies</b></i>';
  }
  if(db) db.textContent = plan === 'sub' ? 'Start the plan' : 'Add to cart';
}

function setPlan(el){ plan = el.dataset.plan; render(); }
function setQty(el){ qty = +el.dataset.qty; render(); }

/* ---- carrinho -----------------------------------------------------------
   Assinatura e compra unica ligadas. A diferenca entre as duas e uma linha:
   o selling_plan so vai no payload quando o cliente escolhe o plano. */
var ONCE_ENABLED = true;

/* Comprar SUBSTITUI o carrinho, nao soma (assets/carrinho-substitui.js):
   esvazia antes de adicionar e ignora o toque duplo. Sem aquele arquivo na
   pagina, compra como antes — o fetch direto. Nome com prefixo porque este
   arquivo nao e um IIFE: tudo aqui vira global na pagina. */
function lpAdicionar(items){
  var cs = typeof window !== 'undefined' && window.carrinhoSubstitui;
  if(cs) return cs.adicionar(items);
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(r){ return r.ok ? r.json() : r.json().then(function(e){ throw e; }); });
}

function buy(ev){
  if(ev) ev.preventDefault();
  var item = LP_DATA[qty];
  if(!item || !item.available) return say('Sold out — pick another size');
  if(plan === 'sub' && !item.planId) return say('Subscription unavailable here');
  if(plan === 'once' && !ONCE_ENABLED) return say('One-time purchase coming soon');

  var line = { id: item.variantId, quantity: 1 };
  if(plan === 'sub') line.selling_plan = item.planId;

  /* brindes: a mesma regra que o bloco de presentes mostra na tela precisa
     valer no carrinho, senao a pagina promete e o checkout nao entrega.
     Brinde e linha separada a $0,00 — sem selling_plan, para nao recorrer. */
  var lines = [line];
  LP_GIFTS.forEach(function(g){
    var need = plan === 'sub' ? g.needSub : g.needOnce;
    if(typeof need === 'number' && need > 0 && qty >= need){
      /* sem propriedade de download: line item property aparece no carrinho e no
         checkout, ou seja, antes de pagar. O brinde e entregue depois, no e-mail
         de confirmacao do pedido. */
      lines.push({ id: g.variantId, quantity: 1 });
    }
  });

  var btn = document.getElementById('buybtn');
  if(btn) btn.setAttribute('aria-busy', 'true');

  lpAdicionar(lines)
  .then(function(){ window.location.href = '/checkout'; })
  .catch(function(e){
    if(btn) btn.removeAttribute('aria-busy');
    console.error('[lp-offer] /cart/add.js falhou', e);
    say((e && e.description) || 'Could not add to cart — try again');
  });
}

/* devolve o recado na propria linha de termos, sem alert() */
function say(msg){
  var t = document.getElementById('terms');
  if(t) t.innerHTML = '<b>' + msg + '</b>';
  return false;
}

if(readOffer()){
  var b = document.getElementById('buybtn');
  if(b) b.addEventListener('click', buy);
  /* voltou do checkout pelo "voltar" (pagina restaurada do bfcache): o botao
     nao pode ficar marcado como ocupado */
  if(typeof window !== 'undefined' && window.addEventListener){
    window.addEventListener('pageshow', function(e){
      if(e.persisted && b) b.removeAttribute('aria-busy');
    });
  }
  render();
} else {
  /* sem dados da loja a LP nao inventa preco: some com o bloco de compra */
  console.error('[lp-offer] sem #lp-offer-data — o produto da section nao foi encontrado');
  var buybox = document.getElementById('buybtn');
  if(buybox) buybox.style.display = 'none';
}
